import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import { LANDING_COLORS } from '../../../constants'

export const HeroContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  padding: 90px 0;
  background-color: ${LANDING_COLORS.bg};
`

export const HeroTitle = styled.h1`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 38px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.57px;
  text-align: center;
  color: ${COLORS.textPrimary};
`

export const HeroTitleAccent = styled.span`
  color: ${LANDING_COLORS.brand};
`

export const HeroIllust = styled.img`
  width: 257px;
  height: auto;
`

export const HeroSubCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`

export const HeroSubCopyTop = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.24px;
  color: ${COLORS.textTertiary};
`

export const HeroSubCopyBottom = styled.p`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.33px;
  color: ${LANDING_COLORS.brand};
`
